import { portalDefaultTheme } from '../portalsTheme'

import { advancedFiltersTheme } from './advancedFilters.theme'
import { assigneeGroupsTheme } from './assigneeGroups.theme'
import { assignFriendTheme } from './assignFriend.theme'
import { authTheme } from './auth.theme'
import { automationWorkflowsTheme } from './automationWorkflows.theme'
import { boardsTheme } from './boards.theme'
import { calls } from './calls.theme'
import { cloudCallingTheme } from './cloudCalling.theme'
import { colorTheme } from './color.theme'
import { commonTheme } from './common.theme'
import { crmItemCreationTheme } from './crmItemCreation.theme'
import { crmItemDetailedViewTheme } from './crmItemDetailedView.theme'
import { crmItemLayouts } from './crmItemLayouts.theme'
import { customObjectTheme } from './customObject.theme'
import { dataCoPilot } from './dataCoPilot.theme'
import { errorViewTheme } from './errorViews.theme'
import { filterModalTheme } from './filterModal.theme'
import { globalSearchTheme } from './globalSearch.theme'
import { leadDetailsRouteTheme } from './leadDetailsRoute.theme'
import { leadDistributionTheme } from './leadDistribution.theme'
import { listsTheme } from './lists.theme'
import { iamTheme } from './iam.theme'
import { navbarTheme } from './navbar.theme'
import { operationsHubTheme } from './operationsHub.theme'
import { parameterStoreTheme } from './parameterStore.theme'
import { pipelineActivitiesTheme } from './pipelineActivities.theme'
import { pipelineEventsTheme } from './pipelineEvents.theme'
import { pipelineTaskTemplatesTheme } from './pipelineTaskTemplates.theme'
import { pipelineItemScheduling } from './pipelineItemScheduling.theme'
import { pipelineSettingsThemes } from './pipelineSettings.theme'
import { reminders } from './reminders.theme'
import { renameBoardTheme } from './renameBoard.theme'
import { renameBoardListTheme } from './renameBoardList.theme'
import { routeWithSidebarTheme } from './routeWithSidebar.theme'
import { selfServeCommon } from './selfServeCommon.theme'
import { selfServeLeadTemplate } from './selfServeLeadTemplate.theme'
import { selfServeTemplates } from './selfServeTemplates.theme'
import { sharableResources } from './sharableResources.theme'
import { sidePaneTheme } from './sidePane.theme'
import { sidebarTheme } from './sidebar.theme'
import { simpleTableTheme } from './simpleTable.theme'
import { tableViewTheme } from './tableView.theme'
import { tasksAndActivitiesTheme } from './tasksAndActivities.theme'
import { templatesCoreTheme } from './templatesCore.theme'
import { testingTheme } from './testingTheme'
import { toastTheme } from './toast.theme'
import { views } from './views.theme'
import { stagesTheme } from './stages.theme'
import { userTemplateTheme } from './userTemplate.theme'
import { whatsappIntegrations } from './whatsappIntegrations.theme'
import { dealTemplateThemes } from './dealTemplate.theme'
import { notificationsThemes } from './notifications.theme'
import { applicationTemplateTheme } from './applicationTemplate.theme'
import { portalsTheme } from './portals.theme'
import { displayStages } from './displayStages.theme'
import { documentTemplateTheme } from './documentTemplate.theme'
import { scoringTheme } from './scoring.theme'
import { pluginsTheme } from './plugins.theme'
import { aiChatSupport } from './aiChatSupport.theme'
import { notes } from './notes.theme'
import { dataLoadingTheme } from './dataLoading.theme'
import { paymentRequests } from './paymentRequests.theme'
import { remarks } from './remarks.theme'
import { entityConditionTheme } from './entityCondition.theme'
import pmuPortalTheme from './pmuPortal.theme'
import { legacyApplicationTheme } from './legacyApplication.theme'
import { searchAndMonitoringTheme } from './searchAndMonitoring.theme'
import { permissionsTheme } from './permissions.theme'

export const defaultTheme = {
   light: {
      ...portalDefaultTheme.light,

      testingThem: testingTheme.light,
      tasksAndActivitiesTheme: tasksAndActivitiesTheme.light,
      boards: boardsTheme.light,
      common: commonTheme.light,
      managerApp: {
         leadDetailsRoute: leadDetailsRouteTheme.light,
         sidePaneTheme: sidePaneTheme.light
      },
      filterModalTheme: filterModalTheme.light,
      globalSearch: globalSearchTheme.light,
      selfServeLeadTemplate: selfServeLeadTemplate.light,
      selfServeTemplates: selfServeTemplates.light,
      sidebar: {
         sidebarTheme: sidebarTheme.light
      },
      routeWithSidebarTheme: routeWithSidebarTheme.light,
      errorViewTheme: errorViewTheme.light,
      views: views.light,
      calls: calls.light,
      pipelineItemScheduling: pipelineItemScheduling.light,
      toast: toastTheme.light,
      lists: listsTheme.light,
      renameBoardListTheme: renameBoardListTheme.light,
      renameBoardTheme: renameBoardTheme.light,
      auth: authTheme.light,
      automationWorkflows: automationWorkflowsTheme.light,
      parameterStore: parameterStoreTheme.light,
      advancedFilters: advancedFiltersTheme.light,
      colorTheme: colorTheme.light,
      reminders: reminders.light,
      crmItemDetailedView: crmItemDetailedViewTheme.light,
      cloudCalling: cloudCallingTheme.light,
      tableView: tableViewTheme.light,
      leadDistribution: leadDistributionTheme.light,
      operationsHub: operationsHubTheme.light,
      simpleTable: simpleTableTheme.light,
      iam: iamTheme.light,
      navbar: navbarTheme.light,
      crmItemCreation: crmItemCreationTheme.light,
      templatesCore: templatesCoreTheme.light,
      customObject: customObjectTheme.light,
      pipelineEventsTheme: pipelineEventsTheme.light,
      pipelineActivityTheme: pipelineActivitiesTheme.light,
      pipelineTaskTemplatesTheme: pipelineTaskTemplatesTheme.light,
      stagesTheme: stagesTheme.light,
      userTemplateTheme: userTemplateTheme.light,
      whatsappIntegrations: whatsappIntegrations.light,
      pipelineSettingsThemes: pipelineSettingsThemes.light,
      sharableResources: sharableResources.light,
      dealTemplate: dealTemplateThemes.light,
      notifications: notificationsThemes.light,
      applicationTemplate: applicationTemplateTheme.light,
      portalsTheme: portalsTheme.light,
      displayStages: displayStages.light,
      documentTemplate: documentTemplateTheme.light,
      scoring: scoringTheme.light,
      plugins: pluginsTheme.light,
      dataCoPilot: dataCoPilot.light,
      assigneeGroups: assigneeGroupsTheme.light,
      assignFriend: assignFriendTheme.light,
      selfServeCommon: selfServeCommon.light,
      crmItemLayouts: crmItemLayouts.light,
      aiChatSupport: aiChatSupport.light,
      notes: notes.light,
      dataLoading: dataLoadingTheme.light,
      paymentRequests: paymentRequests.light,
      remarks: remarks.light,
      entityConditionTheme: entityConditionTheme.light,
      pmuPortal: pmuPortalTheme.light,
      legacyApplication: legacyApplicationTheme.light,
      searchAndMonitoring: searchAndMonitoringTheme.light,
      permissionsTheme: permissionsTheme.light
   },

   dark: {
      ...portalDefaultTheme.dark
   }
}
